'use strict';


export default function($timeout) {
	'ngInject';

	return {
		link: postLink,
		template: '{{ timeElapsed }}',
		scope: {
			reference: '<',
		},
	};

	function postLink(scope, element, attrs) {
		var reference, timeout;

		scope.$watch('reference', function(value) {
			reference = value;
			update();
		});

		$timeout(update);

		function update() {
			if (timeout) $timeout.cancel(timeout);
			scope.timeElapsed = getTimeElapsed(reference);
			timeout = $timeout(update, 60000);
		}
	}
}


function pl(x, unit, units) {
	if (!units) units = unit;
	if (x > 1) return `${x}${units}`;
	if (x == 1) return `1${unit}`;
	return '';
}


function getTimeElapsed(date) {
	var time = Date.parse(date),
		timeNow = new Date().getTime(),
		difference = timeNow-time,
		seconds = Math.floor(difference/1000),
		minutes = Math.floor(seconds/60),
		hours = Math.floor(minutes/60),
		days = Math.floor(hours/24),
		sieve = [days, hours, minutes];

	if (days > 0) {
		return `${pl(days, 'd')}`;
	} else if (hours > 0) {
		return `${pl(hours, 'h')} ${pl(minutes % 60, 'm')}`;
	} else if (minutes > 0) {
		return pl(minutes, 'm');
	} else {
		return '<1m';
	}
}
